// project
import * as C from "@/components.tags/view-tag";

export const ViewTag = {
	path: "/tags/:tagId",
	name: "view-tag",
	component: C.ViewTag,
	meta: {
		title: "Tag"
	},
};